import { NgModule } from '@angular/core';
import { VersionRendererComponent } from './components/version-renderer/version-renderer.component';

import { NoopScrollStrategy, Overlay } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { WLCM_ERRORS } from '@wlcm/angular/forms';
import { FORM_ERRORS } from './constants/form-errors.constants';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiTokenInterceptor } from './services/interceptors/api-token.interceptor';
import { ApiUrlnterceptor } from './services/interceptors/api-url.interceptor';
import { ErrorInterceptor } from './services/interceptors/error.interceptor';
import { MAT_DIALOG_SCROLL_STRATEGY } from '@angular/material/dialog';

export function noopDialogScrolling(overlay: Overlay): () => NoopScrollStrategy {
  return () => overlay.scrollStrategies.noop();
}

@NgModule({
  imports: [CommonModule],
  declarations: [VersionRendererComponent],
  exports: [VersionRendererComponent],
  providers: [
    { provide: WLCM_ERRORS, useValue: FORM_ERRORS },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { verticalPosition: 'bottom', horizontalPosition: 'end' },
    },
    {
      provide: MAT_DIALOG_SCROLL_STRATEGY,
      useFactory: noopDialogScrolling,
      deps: [Overlay],
    },
    { provide: HTTP_INTERCEPTORS, useClass: ApiUrlnterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiTokenInterceptor, multi: true },
  ],
})
export class CoreModule {}
